import React from 'react'
import ReflectionsFeed from '../components/ReflectionsFeed'
import { useReflections } from '../api/selectors'

const ReflectionsPanel = () => <ReflectionsFeed reflections={useReflections()} />

export default ReflectionsPanel
